import * as React from "react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { State } from "../../../../core/store/interfaces";
import {
  LeadVehicle,
  useLead,
  useHasPermission,
  AppPermissions,
  LeadInterestedProject,
} from "../../../../core";
import api from "../../../../api";
import InterestedProjectEdit from "./InterestedProjectEdit";

const InterestedProjects: React.FunctionComponent<{
  onUpdateConfiguration?: () => void;
  onUpdate?: () => void;
}> = (props) => {
  const leadState = useSelector((state: State) => state.lead);
  // console.log('leadState', leadState)
  const canUpdateLeadVehicle = useHasPermission(
    AppPermissions.UpdateLeadVehicle
  );

  const [editDetailsData, setEditDetailsData] = React.useState<{
    isModalOpen?: boolean;
    vehicle?: LeadInterestedProject;
  }>({});

  const interestedProject = leadState?.leadDetails?.interestedProject;

  return interestedProject && interestedProject.length > 0 ? (
    <>
      <div className="px-4 py-3 bg-gray-100 border-top border-bottom ">
        <h6 className="mb-0">Interested Projects</h6>
      </div>

      {interestedProject?.map((vehicle, index) => {
        return (
          <div
            className={`d-flex px-4 py-3 font-sm font-weight-semibold position-relative vehicle-blk ${
              index !== interestedProject.length - 1 ? "border-bottom" : ""
            } `}
          >
            <div className="d-flex w-100 col-9 pl-0">
              {vehicle.project?.projectName} {vehicle.property?.propertyName}
            </div>

            {canUpdateLeadVehicle && leadState?.leadDetails?.isEditable && (
              <div className="d-flex position-absolute vehicle-edit">
                {!leadState.leadDetails?.isDeal && (
                  <i
                    onClick={() =>
                      setEditDetailsData({ isModalOpen: true, vehicle })
                    }
                    className="align-items-center bg-white border contact-edit cursor-pointer d-flex icon-box icon-edit justify-content-center ml-auto"
                  ></i>
                )}
              </div>
            )}
          </div>
        );
      })}

      {editDetailsData.isModalOpen && (
        <InterestedProjectEdit
          onClose={() => setEditDetailsData({})}
          vehicle={editDetailsData.vehicle}
          leadId={leadState.leadDetails?._id}
        ></InterestedProjectEdit>
      )}
    </>
  ) : (
    <></>
  );
};

export default InterestedProjects;
